import BusinessesTitle from './BusinessesTitle.component';

export default BusinessesTitle;
